/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Upload_Raw_FailedInputs */



/**
* | output |
* | --- |
* | "There was an error uploading the RAW VANC data file to temp storage." |
*
* @param {Subtitle_Export_Upload_Raw_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_upload_raw_failed = /** @type {((inputs?: Subtitle_Export_Upload_Raw_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Upload_Raw_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur s'est produite lors du chargement du fichier de données RAW VANC vers le stockage temporaire.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Hochladen der RAW-VANC-Datendatei in den temporären Speicher ist ein Fehler aufgetreten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si è verificato un errore durante il caricamento del file di dati RAW VANC nell'archivio temporaneo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Произошла ошибка при загрузке файла с исходными данными VANC во временное хранилище.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se produjo un error al cargar el archivo de datos RAW VANC al almacenamiento temporal.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将 RAW VANC 数据文件上传到临时存储时出错。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("RAW VANC データ ファイルを一時ストレージにアップロード中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("RAW VANC डेटा फ़ाइल को अस्थायी संग्रहण में अपलोड करने में त्रुटि हुई।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ocorreu um erro ao carregar o arquivo de dados RAW VANC para o armazenamento temporário.")
	return /** @type {LocalizedString} */ ("There was an error uploading the RAW VANC data file to temp storage.")
});